export default "__VITE_ASSET__a8vk5uh2__"